var t={tip:"lds-tip",important:"lds-tip--important",white:"lds-tip--white",caret:"lds-tip--caret",buttons:"lds-tip--buttons",okButton:"lds-tip--ok-button",skipButton:"lds-tip--skip-button"};export{t as default};
